import Dashboard from "../views/dashboard";
import MainLayout from "../layout"
// import Rounds from "../views/rounds/Rounds";
import CreateRound from "../views/startups/rounds/CreateRound";
import CustomControlsView from "../views/controls/CustomControlsView";
import Error404 from "../ui-components/Error404";
import MyForm from "../views/controls/MyForm";
import ViewRound from "../views/startups/rounds/ViewRound";
import WelcomeScreen from "../views/dashboard/WelcomeScreen";
import { Grid } from "@mui/material";
import ThemeBGWrapper from "../ui-components/ThemeBGWrapper";
import Reports from "../views/reports/Reports";
import ViewReport from "../views/reports/CreateReport";
import StartupDetail from '../views/startupDetail'
import Profile from "../views/Profile/Profile";
import UpdateProfile from "../views/Profile/UpdateProfile";
import UpdateStartupProfile from "../views/startups/updateProfile";
// import ApplicationsListing from "../views/deal_flow";
import ApplicationsListing from "../views/startup_applications";
// Deal Flow shell: renders the table ("List") or the kanban board ("Cards") on the
// same route — the header toggle flips the view without changing the URL.
import DealFlowShell from "../views/deal_flow_shell";
import StartupsListing from "../views/startups";
import BackrrStartupsListing from "../views/backrr_startups";
import BackrrInvestorsListing from "../views/backrr_investors";
import ViewApplicationDetail from "views/startup_applications/viewDetails";
import ViewStartupDetail from "views/startups/viewDetails";
import OnboardingLayout from "layout/MainContent/OnboardingLayout";
import Cookies from "js-cookie";
import Portfolio from "views/portfolio/Portfolio";
import AddPortfolio from "views/portfolio/AddPortfolio";
import AddUser from "../views/settings/AddUser";
import AddStartupUser from "../views/startups/settings/AddUser"
import ViewSettingsInformation from "../views/settings/index";
import LogoutScreen from "views/pages/LogoutScreen";
import CreateReport from "views/startups/reports/CreateReport";
import EditPerformance from "views/startups/performance/EditPerformance";
import ClaimProfilePage from "views/onboarding/miscellaneous/ClaimProfilePage";
import PersonalDetails from "views/onboarding/miscellaneous/PersonalDetailsPopup";
import SingleSignOn from "views/pages/SingleSignOn";
import PitchReels from "views/pitch-reels";
import ToolsLanding from "views/tools";
import BulkAnalysis from "views/tools/bulk-analysis";
import AnalysisResults from "views/tools/bulk-analysis/AnalysisResults";
import AllAnalysisResults from "views/tools/bulk-analysis/AllAnalysisResults";
import BulkAnalysisStartPage from "views/tools/bulk-analysis/BulkAnalysisStartPage";
import AnalysisDetailPage from "views/tools/bulk-analysis/AnalysisDetailPage";
import OrdersAndInvoices from "views/Subscription/OrdersAndInvoices";
import OnboardingV2 from "views/onboarding-v2";

const MainRoutes = {
    path: '',
    // element: <> />,
    children: [
        {
            path: '',
            element: <MainLayout />,
            children: [
                {
                    path: '/',
                    // element: <Dashboard />
                    element: <DealFlowShell />
                },
                {
                    path: 'deal-flow',
                    children: [
                        {
                            path: '',
                            element: <DealFlowShell />,
                        },
                        // {
                        //     path: 'create_round',
                        //     element: <CreateRound />,
                        //     children: [
                        //         {
                        //             path: '',
                        //         },
                        //         {
                        //             path: ':id',
                        //             // element: <CreateRound />
                        //         },
                        //     ]
                        // },
                        // {
                        //     path: 'edit_round/:id',
                        //     element: <CreateRound />
                        // },
                        // {
                        //     path: 'view-profile',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-round',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-documents',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-funding',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-reports',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-performance',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-feedback',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-notes',
                        //     element: <ViewApplicationDetail />
                        // },
                        {
                            path: ':tab',
                            element: <ViewApplicationDetail />
                        },
                        {
                            path: '*',
                            element: <ViewApplicationDetail />
                        },
                    ]
                },
                {
                    path: 'startups',
                    children: [
                        {
                            path: '',
                            element: <StartupsListing />,
                        },
                        {
                            path: 'add',
                            element: <UpdateStartupProfile />,
                        },
                        {
                            path: 'edit',
                            element: <UpdateStartupProfile />,
                        },
                        // {
                        //     path: 'create_round',
                        //     element: <CreateRound />,
                        //     children: [
                        //         {
                        //             path: '',
                        //         },
                        //         {
                        //             path: ':id',
                        //             // element: <CreateRound />
                        //         },
                        //     ]
                        // },
                        // {
                        //     path: 'edit_round/:id',
                        //     element: <CreateRound />
                        // },
                        // {
                        //     path: 'view-profile',
                        //     element: <ViewStartupDetail />
                        // },
                        // {
                        //     path: 'view-round',
                        //     element: <ViewStartupDetail />
                        // },
                        // {
                        //     path: 'view-documents',
                        //     element: <ViewStartupDetail />
                        // },
                        // {
                        //     path: 'view-reports',
                        //     element: <ViewStartupDetail />
                        // },
                        // {
                        //     path: 'view-performance',
                        //     element: <ViewStartupDetail />
                        // },
                        // {
                        //     path: 'view-feedback',
                        //     element: <ViewStartupDetail />
                        // },
                        // {
                        //     path: 'view-notes',
                        //     element: <ViewStartupDetail />
                        // },
                        {
                            path: 'reports/add-report',
                            element: <CreateReport />
                        },
                        {
                            path: 'reports/edit-report',
                            element: <CreateReport />
                        },
                        {
                            path: 'rounds/add-round',
                            element: <CreateRound />
                        },
                        {
                            path: 'rounds/edit-round',
                            element: <CreateRound />
                        },
                        {
                            path: "rounds/view",
                            element: <ViewRound tabValue="view_details" />
                        },
                        {
                            path: "rounds/view-investors",
                            element: <ViewRound tabValue="round_investors" />
                        },
                        {
                            path: "rounds/view-documents",
                            element: <ViewRound tabValue="documents" />
                        },
                        {
                            path: "performance/add-performance",
                            element: <EditPerformance key={"Add Performance"} />
                        },
                        {
                            path: "performance/edit-performance",
                            element: <EditPerformance key={"Edit Performance"} />
                        },
                        {
                            path: "users/add-user",
                            element: <AddStartupUser key={"Add Startup User"} />
                        },
                        {
                            path: "users/edit-user",
                            element: <AddStartupUser key={"Edit Startup User"} />
                        },
                        {
                            path: ':tab',
                            element: <ViewStartupDetail />
                        },
                        {
                            path: '*',
                            element: <ViewStartupDetail />
                        },
                    ]
                },
                {
                    path: 'profile',
                    children: [
                        {
                            path: '',
                            element: <Profile />,
                        },
                        {
                            path: 'edit_profile',
                            element: <UpdateProfile />
                        },
                        // {
                        //     path: 'view/:id',
                        //     element: <ViewRound />
                        // },
                    ]
                },
                {
                    path: 'portfolio',
                    children: [
                        {
                            path: '',
                            element: <Portfolio />
                        },
                        {
                            path: 'create_portfolio',
                            element: <AddPortfolio />
                        },
                        {
                            path: 'create_portfolio/:id',
                            element: <AddPortfolio />
                        }
                    ]

                },
                {
                    path: 'reports',
                    children: [
                        {
                            path: '',
                            element: <Reports />
                        },
                        {
                            path: 'view',
                            element: <ViewReport />
                        },
                        // {
                        //     path: 'create_report',
                        //     element: <CreateReport />,
                        //     children: [
                        //         {
                        //             path: '',
                        //         },
                        //         {
                        //             path: ':id',
                        //             // element: <CreateReport />
                        //         },
                        //     ]
                        // },
                        // {
                        //     path: 'edit_report/:id',
                        //     element: <CreateReport />
                        // }
                        // ,
                        // {
                        //     path: 'view/:id',
                        //     element: <ViewRound />
                        // },
                    ],
                },
                {
                    path: "settings",
                    children: [
                        {
                            path: "",
                            element: <ViewSettingsInformation />
                        },
                        {
                            path: "users",
                            element: <ViewSettingsInformation tabValue={"users"} />
                        },
                        {
                            path: "deal-flow",
                            element: <ViewSettingsInformation tabValue={"deal-flow"} />
                        },
                        {
                            path: "add_user",
                            element: <AddUser />
                        },
                    ]
                },
                {
                    path: 'tools',
                    children: [
                        {
                            path: '',
                            element: <ToolsLanding />,
                        },
                        // {
                        //     path: ':tab',
                        //     element: <ToolsLanding />,
                        // },
                        // {
                        //     path: 'bulk-analysis',
                        //     element: <BulkAnalysis />,
                        // },
                        // {
                        //     path: 'bulk-analysis/results/:batch_id',
                        //     element: <AnalysisResults />,
                        // },
                        {
                            path: 'bulk-analysis',
                            element: <AllAnalysisResults />,
                        },
                        {
                            path: 'bulk-analysis/detail/:file_id',
                            element: <AnalysisDetailPage />,
                        },
                        {
                            path: 'bulk-analysis/start',
                            element: <BulkAnalysisStartPage />,
                        },
                    ],
                },
                {
                            path: 'bulk-analysis',
                            element: <AllAnalysisResults />,
                        },
                        {
                            path: 'bulk-analysis/detail/:file_id',
                            element: <AnalysisDetailPage />,
                        },
                        {
                            path: 'bulk-analysis/start',
                            element: <BulkAnalysisStartPage />,
                        },
                {
                    path: "pitch-reels" ,
                    children: [
                        {
                            path: "",
                            element: <PitchReels value={"deal-flow"} />
                        },
                        {
                            path: "preference",
                            element: <PitchReels value={"preference"} />
                        },
                        {
                            path: "deal-flow",
                            element: <PitchReels value={"deal-flow"} />
                        },
                        {
                            path: "selected",
                            element: <PitchReels value={"selected"} />
                        },
                        {
                            path: "all",
                            element: <PitchReels value={"all"} />
                        }
                        // {
                        //     path: "alt",
                        //     element: <VideoReelPlayer />
                        // }
                    ]
                },
                // {
                //     path: 'orders-invoices',
                //     children: [
                //         {
                //             path: '',
                //             element: <OrdersAndInvoices value="one-time" />,
                //         },
                //         {
                //             path: ':tab',
                //             element: <OrdersAndInvoices />,
                //         },
                //     ]
                // },
                {
                    path: '*',
                    element: <ApplicationsListing />
                },
            ]
        },
        // {
        //     path: 's',
        //     element: <StartupDetail />
        // },
        {
            path: '/welcome',
            element: <OnboardingLayout> <WelcomeScreen /></OnboardingLayout>,
        },
        {
            path: "/logout",
            element: <LogoutScreen />
        },
        {
            path: '/activate-profile',
            element: <OnboardingLayout><ClaimProfilePage /></OnboardingLayout>,
        },
        {
            path: '/cHJpdmF0ZS1yb3V0ZQ==',
            element: <SingleSignOn />,
        },
        // New 3-step onboarding — reachable with a complete profile so it can be reviewed.
        // Must NOT be the first child: AdminRoutes does
        // `...MainRoutes.children.find(item => item).children`, which takes the first
        // entry and spreads its `children`. A first entry without `children` breaks it.
        {
            path: '/onboardingv2',
            element: <OnboardingV2 />,
        },
    ]
};

export default MainRoutes;
